import { gql } from "@apollo/client"

export const ROUND_RESET = gql`
  mutation RoundReset($RoundResetInput: RoundResetInput!) {
    RoundReset(input: $RoundResetInput) {
      status {
        success
        name
        detail
      }
    }
  }
`
